export enum InvestigationAttendanceStatus {
	NotRecorded = 1,
	Present = 2,
	Absent = 3,
}
